import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { ObservacioPda } from '../../models/observacions-pda.model';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmationDialogService } from 'path-shared/components/confirmation-dialog/confirmation-dialog.service';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { ObservacionsPdaService } from '../../services/observacions-pda.service.ts.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { FormService } from 'path-shared/services/form/form.service';
import { Builder } from 'path-shared/models/builder';
import { StartupService } from 'path-shared/services/startup/startup.service';
import { CFG_TIPODENUNCIA } from 'path-models/CFG_TIPODENUNCIA';
import { Dictionary } from 'path-shared/models/dictionary';

@Component({
  selector: 'app-observacions-pda-editor',
  templateUrl: './observacions-pda-editor.component.html',
  styleUrls: ['./observacions-pda-editor.component.scss']
})
export class ObservacionsPdaEditorComponent implements OnInit {

  secure_id: string;
  observacionsPda: ObservacioPda;
  dialogData: ComponentDialog;
  closeButtonText: string;
  tipusDenuncia = [];

  @ViewChild('mainForm') private mainForm: ElementRef;

  constructor(
    private dialog: MatDialog,
    private confirmationDialogService: ConfirmationDialogService,
    public auth: AuthorizationService,
    private observacionsPdaService: ObservacionsPdaService,
    private i18n: I18n,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    public thisDialogRef: MatDialogRef<ObservacionsPdaEditorComponent>,
    private formService: FormService,
    private startupService: StartupService,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.observacionsPda = Builder.newObservacioPda();
      this.dialogData = data;
      this.secure_id = this.dialogData.id;
      if (this.dialogData.isReadOnly) {
        this.closeButtonText = this.i18n('Tancar');
      } else {
        this.closeButtonText = this.i18n('Llista');
      }
      this.startupService.GetTiposDenuncia().forEach((tipusDenuncia: CFG_TIPODENUNCIA) => {
        this.tipusDenuncia.push(new Dictionary(tipusDenuncia.CODI, tipusDenuncia.DESCRIPCIO));
      });
   }

  ngOnInit() {
    if (this.secure_id !== null) {
      this.observacionsPdaService.getObservacioPda(this.secure_id).subscribe(data => {
        this.observacionsPda = data;
      });
    }
  }

  save() {
    if (this.formService.allFieldsValid(this.mainForm)) {

      this.observacionsPdaService.setObservacioPda(this.observacionsPda).subscribe(result => {
        this.toastr.info(this.i18n('Observación PDA guardada correctamente'));
        this.thisDialogRef.close(true);
      });
    } else {
      this.toastr.warning(this.i18n('Hi ha errors en el formulari!'));
      if (!this.mainForm.nativeElement.classList.contains('displayErrors')) {
        this.mainForm.nativeElement.classList.add('displayErrors');
      }
    }
  }

  cancel() {
    this.thisDialogRef.close(false);
  }

  remove() {
    this.confirmationDialogService.confirm(this.i18n('Confirmi'), this.i18n('Seguro que desea eliminar la observación PDA?'))
    .then((confirmed) => {
        if (confirmed) {
          this.observacionsPdaService.removeObservacioPda(this.secure_id).subscribe(result => {
            this.toastr.success(this.i18n('Observación PDA eliminada correctamente'));
            this.dialog.closeAll();
            this.thisDialogRef.close(true);
          });
        }
      });
  }

}
